import React from "react";
import { Reveal } from "./Reveal";
import { indiaMapDefault } from "../data/indiaMap";

export default function IndiaMapSection({ data, lang = "en" }) {
  const d = { ...indiaMapDefault, ...(data || {}) };

  const L = (en, hi, def) => {
    const v = lang === "hi" ? (d[hi] || d[en]) : d[en];
    return v && String(v).trim() ? v : def;
  };
  const eyebrow = L("eyebrow_en", "eyebrow_hi", indiaMapDefault.eyebrow_en);
  const heading = L("heading_en", "heading_hi", indiaMapDefault.heading_en);
  const subtitle = L("subtitle_en", "subtitle_hi", indiaMapDefault.subtitle_en);
  const mapImage = (d.map_image && String(d.map_image).trim()) || indiaMapDefault.map_image;

  const stats = [
    { value: d.accommodations_count || indiaMapDefault.accommodations_count, label: lang === "hi" ? "एकोमोडेशन" : "Accommodations" },
    { value: d.states_count || indiaMapDefault.states_count, label: lang === "hi" ? "राज्य" : "States" },
    { value: d.cities_count || indiaMapDefault.cities_count, label: lang === "hi" ? "शहर" : "Cities" },
  ];

  return (
    <section className="relative bg-gradient-to-b from-[#F4F6FA] to-white overflow-hidden py-20 lg:py-28" data-testid="india-map-section">
      <div className="absolute top-0 right-0 w-[460px] h-[460px] rounded-full bg-[#E84B1C]/8 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="font-head text-[#E84B1C] font-semibold tracking-wide uppercase text-sm">{eyebrow}</span>
          <h2 className="mt-3 font-head text-3xl md:text-5xl font-bold text-[#12284B] leading-tight">{heading}</h2>
          {subtitle && <p className="mt-4 text-black/70 text-lg leading-relaxed">{subtitle}</p>}
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 mx-auto max-w-[760px]">
            <img
              src={mapImage}
              alt="Map of India showing Superhost Cloud presence across states"
              className="w-full h-auto select-none"
              loading="lazy"
              data-testid="india-map-image"
            />
          </div>
        </Reveal>

        {/* Stats strip */}
        <Reveal delay={0.25}>
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-3xl mx-auto">
            {stats.map((s, i) => (
              <div
                key={i}
                data-testid={`map-stat-${i}`}
                className="text-center rounded-2xl bg-white border border-[#12284B]/10 shadow-lg shadow-[#12284B]/5 px-6 py-7 transition-all duration-300 hover:border-[#E84B1C]/40 hover:-translate-y-1"
              >
                <div className="font-head text-4xl font-extrabold text-[#E84B1C] leading-none">{s.value}</div>
                <div className="mt-2 text-[#12284B]/70 font-medium">{s.label}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
